module.exports = __webpack_public_path__ + "0c0d7f380c650a180ca14d15dfcf9cdd.svg";